import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import WhatWeDo from './pages/WhatWeDo';
import OurValues from './pages/OurValues';
import Sustainability from './pages/Sustainability';
import OlderAdults from './pages/OlderAdults';
import Catalogues from './pages/Catalogues';
import TryTSU from './pages/TryTSU';
import Contact from './pages/Contact';
import FAQs from './pages/FAQs';
import Partner from './pages/Partner';
import TheBiz from './pages/TheBiz';
import ShippingPolicy from './pages/ShippingPolicy';
import TermsOfService from './pages/TermsOfService';
import ReturnsPolicy from './pages/ReturnsPolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';
import NDIS from './pages/NDIS'; // ADD THIS IMPORT
import {
  MensCollection,
  WomensCollection,
  KidsCollection,
} from './pages/CollectionPage';
import NewsMedia from './pages/NewsMedia';
import Cart from './pages/Cart';
import Wishlist from './pages/Wishlist';
import { ShopProvider } from './context/ShopContext';
import './App.css';
import ChatWidget from './components/ChatWidget';
import AccessibilityWidget from './components/AccessibilityWidget';

function App() {
  return (
    <ShopProvider>
      <Router>
        <div className="app">
          <Navigation />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/our-values" element={<OurValues />} />
            <Route path="/sustainability" element={<Sustainability />} />
            <Route path="/older-adults" element={<OlderAdults />} />
            <Route path="/catalogues" element={<Catalogues />} />
            <Route path="/try-tsu" element={<TryTSU />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/partner" element={<Partner />} />
            <Route path="/thebiz" element={<TheBiz />} />
            <Route path="/biz" element={<TheBiz />} />
            <Route path="/mens" element={<MensCollection />} />
            <Route path="/mens/:subCategory" element={<MensCollection />} />
            <Route path="/womens" element={<WomensCollection />} />
            <Route path="/womens/:subCategory" element={<WomensCollection />} />
            <Route path="/kids" element={<KidsCollection />} />
            <Route path="/kids/:subCategory" element={<KidsCollection />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/wishlist" element={<Wishlist />} />
            {/* Policy routes */}
            <Route path="/shipping-policy" element={<ShippingPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/returns" element={<ReturnsPolicy />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/what" element={<WhatWeDo />} />
            <Route path="/what/:section" element={<WhatWeDo />} />
            {/* ADD THIS NEW ROUTE */}
            <Route path="/ndis" element={<NDIS />} />
            <Route path="/news" element={<NewsMedia />} />
            <Route path="/news/:slug" element={<NewsMedia />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <Footer />
          <ChatWidget />
          <AccessibilityWidget />
        </div>
      </Router>
    </ShopProvider>
  );
}

export default App;
